import { faCopy } from '@fortawesome/free-solid-svg-icons'
import { CopyText, EditableLabelContent, LabelContent } from 'V2Components'
import { isOrgAccount, useCloudDetailsProvider, useCloudsResources } from 'features/clouds'
import { getResourceName } from 'features/resources'
import { IconButton, Label, TargetIcon } from 'procyon-ui'
import React, { useState } from 'react'
import { SSHPublicKeyLabelContent } from '../SSHPublickeyLabelContent'
import { AccountNotificationChannels } from '../../../AccountNotificationChannels'
import { getHTMLDataTestID } from 'infra/utils'

const AZUREAccount = ({}) => {
  const { cloud: account } = useCloudDetailsProvider()
  const [description, setDescription] = useState(account.Spec.Description)
  const { getAccountTargets } = useCloudsResources()
  const isOrg = isOrgAccount(account)
  const targets = getAccountTargets(account)

  const IconTypeMap = {
    Server: 'SERVER',
    Database: 'DATABASE',
    KubeCluster: 'KUBE_CLUSTERS',
    KubeNamespace: 'KUBE_NAMESPACES',
    RDPServer: 'RDP_SERVER'
  }

  return (
    <div>
      <LabelContent data-testid={'name'} content={getResourceName(account)} title='Name' />
      <EditableLabelContent
        value={description}
        onChange={(e) => setDescription(e.target.value)}
        title='Description'
        content={account.Spec.Description}
        editMode={false}
        showEmptyLabel
      />
      <LabelContent
        data-testid={'tenant-id'}
        content={
          <>
            <CopyText
              showText
              messageKey='Tenant ID'
              text={account.Spec.AzureSpec.TenantID}
              Component={<IconButton size='sm' icon={faCopy} variant='gray' />}
            />
          </>
        }
        title='Tenant ID'
      />
      <LabelContent
        data-testid={'procyon-appid'}
        content={
          <>
            <CopyText
              showText
              messageKey='Privilege App ID'
              text={account.Spec.AzureSpec.ProcyonAppID}
              Component={<IconButton size='sm' icon={faCopy} variant='gray' />}
            />
          </>
        }
        title='Privilege App ID'
      />

      <LabelContent
        data-testid={'notification-channel'}
        title='Notification Channels'
        content={
          <div className='flex gap-2 flex-wrap'>
            <AccountNotificationChannels
              account={account}
              Fallback={<Label text='No Channels' />}
            />
          </div>
        }
      />
      {!isOrg && (
        <>
          {Object.entries(targets).map(([targetType, config]) => {
            const count = targets[targetType]?.length || 0
            if (count === 0) return null

            return (
              <LabelContent
                key={targetType}
                data-testid={targetType.toLowerCase()}
                dataTestId={getHTMLDataTestID('cloud-details', 'p', targetType)}
                title={targetType}
                content={
                  <Label
                    icon={<TargetIcon className='rounded' type={IconTypeMap[targetType]} />}
                    text={count}
                  />
                }
              />
            )
          })}
        </>
      )}
      <SSHPublicKeyLabelContent />
    </div>
  )
}

export { AZUREAccount }
